module.exports = __webpack_public_path__ + "static/SocialDropHeroMobile-bcba1840458923169a210391315bd8b5.svg";